import { render, staticRenderFns } from "./VacancyQuestionsGroup.vue?vue&type=template&id=4e935a4c&scoped=true&"
import script from "./VacancyQuestionsGroup.vue?vue&type=script&lang=js&"
export * from "./VacancyQuestionsGroup.vue?vue&type=script&lang=js&"
import style0 from "./VacancyQuestionsGroup.vue?vue&type=style&index=0&id=4e935a4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e935a4c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListItemGroup } from 'vuetify/lib/components/VList';
installComponents(component, {VListItemGroup})
